import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface TermsOfServicePageProps {
  onNavigate: (view: string) => void;
}

const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="terms" onNavigate={onNavigate} />
);

export default TermsOfServicePage;
